import { BASE_URL } from '../../constants/api';
import Fetch from '../fetch';
import Store from '../../stores/Store';

import CacheService from '../../utils/CacheService';

import type {
  BankResponseType,
  SelectOptionType,
  BranchResponseType,
} from '../../types/types';

async function getBank() {
  const store = new Store();
  const token = store.get('token');

  const url = `${BASE_URL}/api/bank/getAll?max=999&offset=0&token=${token}`;

  const json = await CacheService(
    `bank/getAll`,
    async () => {
      const json: BankResponseType[] = await Fetch(url, {
        method: 'POST',
        headers: {
          'x-token': store.get('x-token'),
          'x-csrf': store.get('x-csrf'),
          accept: 'application/json',
        },
        body: JSON.stringify({}),
      });

      const banks: SelectOptionType[] = json.map(item => {
        return {
          code: item.id,
          value: item.name,
        };
      });

      banks.unshift({ code: '', value: 'choose bank' });

      return banks;
    },
    {
      expiry: 60 * 40,
    }
  );

  return json;
}
async function getBranch() {
  const store = new Store();
  const token = store.get('token');

  const url = `${BASE_URL}/api/branch/getAll?token=${token}`;

  const json = await CacheService(
    `branch/getAll`,
    async () => {
      const json: BranchResponseType = await Fetch(url, {
        method: 'GET',
        headers: {
          'x-token': store.get('x-token'),
          'x-csrf': store.get('x-csrf'),
          accept: 'application/json',
        },
      });

      const branches: SelectOptionType[] = json.branch.map(item => {
        return {
          code: item.id,
          value: item.branchName,
        };
      });
      branches.unshift({ code: '', value: 'choose branch' });
      return branches;
    },
    {
      expiry: 60 * 40,
    }
  );

  return json;
}

export async function getOptionsBank({
  category,
  param,
}: {
  category?: string;
  param?: string;
}) {
  let response = [];
  if (category == 'BANK') {
    response = await getBank();
    response[category] = response;
  } else if (category == 'BRANCH') {
    response = await getBranch();
    response[category] = response;
  }
  return category ? response[category] || [] : response;
}
